'use client'

import { cn } from '@/src/utils/styles'

interface MainContentProps {
  children: React.ReactNode
}

export function MainContent({ children }: MainContentProps) {
  return <div className={cn('container px-page-gutter')}>{children}</div>
}
